"use strict";

module.exports = function (accumulator) {
  return accumulator + ' - DOUBLE SIDED';
};